import { Modal, notification } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import { Button } from "../Button";
import { useMediaQuery } from "react-responsive";
import { DESKTOP_WIDTH } from "@bundles/consts";
import InputV2 from "@appComponents/InputV2";
import SecurityService from "@services/Security.service";

type TwoFABackupCodeModalProps = {
  open?: boolean;
  onClose?: () => void;
  handleSetIs2FALocked: (val: boolean) => void;
};

export const TwoFABackupCodeModal = ({
  open,
  onClose,
  handleSetIs2FALocked,
}: TwoFABackupCodeModalProps) => {
  const [backupCode, setBackupCode] = useState("");

  const isButtonEnabled = useMemo(() => backupCode?.length !== 8, [backupCode]);

  const isMobile = useMediaQuery({ maxWidth: DESKTOP_WIDTH });

  const handleOnSubmit = () => {
    SecurityService.twoFaUnlock({ code_2fa: backupCode })
      .then(() => {
        handleSetIs2FALocked(false);
        onClose();
      })
      .catch((err) => {
        if (typeof err.response.data === "string") {
          notification.error({
            message: "Entered Backup Code is incorrect",
          });
        }
      });
  };

  const handleEnterKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" && isButtonEnabled) {
      handleOnSubmit();
    }
  };

  useEffect(() => {
    if (!open) {
      setBackupCode("");
    }
  }, [open]);

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width={isMobile ? "100%" : "70%"}
      className="tailwind-2fa-modal"
    >
      <div>
        <div>
          <h2 className="text-xl font-semibold">
            Authenticate with backup codes
          </h2>

          <div className="mt-2 mb-[40px]">
            If you’ve lost access to your 2FA device, enter one of your backup
            codes to log in. Each code can only be used once.
          </div>

          <InputV2
            value={backupCode}
            onChange={(e) => setBackupCode(e.target.value)}
            label="Backup code"
            placeholder="Type here"
            onKeyDown={handleEnterKeyPress}
            shouldShowIconBeVisible={open}
          />

          <div className="flex flex-col items-center">
            <Button
              isPrimary
              onClick={handleOnSubmit}
              className="mt-[40px] w-full flex items-center gap-2"
              disabled={isButtonEnabled}
            >
              Submit
            </Button>

            <a
              className="underline font-semibold mt-[15px] text-[16px]"
              onClick={onClose}
            >
              Cancel
            </a>
          </div>
        </div>
      </div>
    </Modal>
  );
};
